import { Injectable } from '@angular/core';

const TOKEN_KEY = 'mv_bo_token';
const USER_KEY = 'mv_bo_user';

@Injectable({ providedIn: 'root' })
export class TokenStorage {
  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
  }

  getUser<T>(): T | null {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  }

  setUser<T>(user: T): void {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  clearAll(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem('menuvia_manual_cache_tables');
    localStorage.removeItem('menuvia_manual_cache_menu');
    localStorage.removeItem('menuvia_manual_pending_orders');
  }
}
